//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { parseTime } from "@/utils";
export default {
  props: {
    name: String,
    // date: Date,
    // isShop: { type: Boolean, default: false },
  },
  computed: {
    isShop() {
      return this.$route.name === "Region";
    },
    // dateText() {
    //   return parseTime(this.date, "{y}年{m}月{d}日");
    // },
  },
  methods: {
    back() {
      if (this.$store.state.permission.region.length > 0) {
        this.$router.push("/operate");
      }
    },
    onCityClick() {
      this.$emit("city");
    },
    onDateClick() {
      this.$emit("date");
    },
  },
};
